import type { RegistrationSteps } from '../../../../types'

/**
 * A server `registration_step` value. Typed from the enum so a misspelt step fails
 * type-checking, without loading `common/types` at runtime.
 */
type ServerStep = `${RegistrationSteps}`

const CONFIRMED_STEP: ServerStep = 'confirm'

/**
 * Sep 24 — the registration session is already confirmed: its registration exists,
 * and the server refuses to confirm it again.
 *
 * A Team Budget rep reaches the payment step with such a session only by going Back
 * from the pay page. Offering "Register & Pay" there would only ask the server to
 * register the team a second time.
 */
export const isConfirmedRegistrationSession = (
  session?: { registration_step?: string | null } | null
): boolean => session?.registration_step === CONFIRMED_STEP

/** RegistrationType::REGISTRATION_BY_TEAM, mirrored. */
const TEAM_REGISTRATION_TYPE_ID = 1

/**
 * SN-8441 / SN-8442 — a `payment-confirmed` payload that proves the registration is
 * COMPLETE: the session is confirmed and, for a team, carries the registration its
 * confirmation created. Anything less (an early or partial broadcast) is not a
 * confirmation — the page keeps waiting.
 */
export const isCompleteConfirmedSession = (
  session?: {
    registration_step?: string | null
    registration_type_id?: number | string | null
    linked_team_registration?: { id?: string | null } | null
  } | null
): boolean =>
  isConfirmedRegistrationSession(session) &&
  (Number(session?.registration_type_id) !== TEAM_REGISTRATION_TYPE_ID ||
    Boolean(session?.linked_team_registration?.id))
